import { useSelector } from '@ecommerce/nest-ssr/common';
import Icon from 'atomic/icon/icon';
import React, { MouseEvent, ReactElement } from 'react';
import DealerBadgeInterface from 'interfaces/dealer-badge.interface';
import { shouldShowOfferBadge } from 'helpers/get-filters-offers-count';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import parseStringToNumber from 'helpers/parse-string-to-number';

import './delivery.scss';

declare const window: any;

export const FREE_DELIVERY_PATTERN_WORDS: string[] = [
    'Darmowa dostawa',
    'Dostawa za 0 zł',
    'Dostawa za 0 zl',
    'Dostarczamy za darmo',
    'Wysyłka za 0 zł',
    'Wysylka za 0 zl',
    'Darmowa wysyłka',
    'Darmowa wysylka',
    'Dostawa0zł',
    'Dostawa 0zł',
    'Dostawa 0 zł',
    'Dostawa gratis',
    'Gratis dostawa',
    'Transport gratis',
    'Wysyłka gratis',
    'Gratis wysyłka',
    'Wysylka gratis',
    'Gratis wysylka',
    'Bezpłatny transport',
    'Bezplatny transport',
    'DARMOWY TRANSPORT'
];

const Delivery: React.FC<{
    offerDescription: string;
    className?: string;
    freeDelivery: DealerBadgeInterface | undefined;
    dealerId: number;
}> = ({ className, freeDelivery, dealerId, offerDescription }): ReactElement => {
    const departmentId: number = useSelector((state: { product: ProductInterface; }) => parseStringToNumber(state.product.category.path[0].category.id));
    const productId: number = useSelector((state: { product: ProductInterface; }) => state.product.id);
    const isAmazon = dealerId === 11083;

    const openInNewWindow = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): boolean => {
        window.open((e.target as any).getAttribute('data-url'), '_blank', 'resizable=yes,height=700,width=700');

        return false;
    };

    if (typeof freeDelivery !== 'undefined' && shouldShowOfferBadge(freeDelivery, offerDescription, FREE_DELIVERY_PATTERN_WORDS)
    ) {
        return (
            <span className={`${className || ''} free-delivery`}>
                <Icon color="primary" name="free-delivery" size={14} />
                {' '}
                Darmowa wysyłka
            </span>
        );
    }

    return (
        <button
            onClick={openInNewWindow}
            data-url={isAmazon
                ? 'https://www.amazon.de/gp/help/customer/display.html?nodeId=201910850'
                + '#GUID-94F272E0-F280-4956-87FB-E99C2528462A__SECTION_3C6C049466B041B08CCA2A57FF285314'
                : `/delivery.php?d=${dealerId}&cp=${productId}&dp=${departmentId}`}
            className={`${className || ''} delivery-cost link gtm_oa_shipping`}
            data-action="offer/deliveryCosts"
        >
            + koszty dostawy
        </button>
    );
};

export default Delivery;
